import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  contractorLogo = 'https://meli-kit-info-images.s3.us-east-2.amazonaws.com/keenhome_footer.svg';

  constructor() { }

  ngOnInit() {
  }

}
